module.exports = __webpack_public_path__ + "img/Tareas por Revisar Icono.ae75a8ec.svg";